import * as React from 'react';
import { GetUserNotificationsQuery, NotificationStatusesEnum } from 'types/generated/client';
import NotificationActivityCard, {
  NotificationGameCard,
  type NotificationPillTone,
  NotificationPlayerCard,
} from './NotificationActivityCard';

type PlayRequest = NonNullable<
  GetUserNotificationsQuery['userNotifications'][0]['notificationDetails']
>['primaryEntity']['playRequest'];

export type PlayRequestPillTone = NotificationPillTone;

interface Props {
  status: NotificationStatusesEnum;
  actorName: string;
  actorCoachStatus?: string | null;
  pill: { label: string; tone: PlayRequestPillTone };
  title: string;
  message?: string | null;
  playRequest: PlayRequest;
  /** Availability requests show a player card; this picks whose profile to render.
   *  Requester-facing cards (accepted/declined/cancelled) show the availability
   *  owner (the host); the host-facing received card shows the requester. */
  playerProfile?: 'owner' | 'requester';
}

export default function PlayRequestNotificationCard({
  playRequest,
  playerProfile = 'owner',
  ...cardProps
}: Props) {
  const event = playRequest?.event ?? null;
  const availability = playRequest?.availability ?? null;
  const profile =
    playerProfile === 'requester'
      ? playRequest?.requesterProfile ?? null
      : availability?.userProfile ?? null;

  return (
    <NotificationActivityCard {...cardProps}>
      {event ? (
        <NotificationGameCard event={event} />
      ) : (
        availability && profile && <NotificationPlayerCard profile={profile} />
      )}
    </NotificationActivityCard>
  );
}
